<template>
  <profile-card header-color="blue" class="search-sidebar">
    <template slot="header">
      <div class="card-icon"><md-icon>settings</md-icon></div>
    </template>
    <template slot="content">
      <div class="info-wrap">
        <md-field>
          <label for="keyword-search">Keyword Search</label>
          <md-input
            id="keyword-search"
            v-model="search"
            placeholder="Search..."
            type="text"
            @input="chooseInput"
          ></md-input>
          <md-icon>search</md-icon>
        </md-field>
        <h5 @click="favoriteDrop($event)"><md-icon class="favorites-icon mr-5">star</md-icon>{{ title }}</h5>
        <ul v-if="loaded" class="favorite-list">          
          <li
            v-for="(favorite, index) in favorites"
            :key="index"
            class="favorite-list-item"
          >
            <div class="list-item-head">
              <span class="icon mr-5">
                <md-icon
                  @click.native="
                    chooseFavorite(favorite.data, favorite.search1)
                  "
                  class="add-item"
                  >playlist_add</md-icon
                >
              </span>
              <span class="title">{{ favorite.search1.company_name }}</span>
              <span class="actions ml-5"
                ><md-icon
                  @click.native="removeFavorite(favorite.id, index)"
                  class="delete-item"
                  >delete</md-icon
                ></span
              >
            </div>
            <div class="list-item-body">
              {{ favorite.search1.state + " " + favorite.search1.zip }}
            </div>
          </li>
          <li v-if="favorites == 0"><h6 class="text-center">You don't have any</h6></li>
        </ul>
      </div>
    </template>
  </profile-card>
</template>

<script>
import { ProfileCard } from "@/components";
import axios from "axios";
import { debounce } from "lodash";

export default {
  name: "company-sidebar",
  props: {
    title: {
      type: String,
    },
  },
  components: { ProfileCard },
  data() {
    return {
      search: "",
      favorites: undefined,
      loaded: false,
      debounceHandlerCompany: debounce(() => {
        this.$store.commit("SET_SEARCH_INPUT_COMPANY", this.search);
      }, 3000),
    };
  },
  methods: {
    isRightSalesRange() {
      if (this.salesRangeFrom && this.salesRangeTo) {
        return parseInt(this.salesRangeFrom) < parseInt(this.salesRangeTo);
      }

      return false;
    },
    getName: function(name) {
      return name.split("[")[0];
    },
    getData: function(name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    chooseInput: function() {
      if (this.search) {
        this.$store.commit("SET_SEARCH_COMPANIES", null);
        this.$store.commit("SET_SEARCH_LOADING_COMPANY", true);
        this.debounceInputCompany();
      } else {
        this.$store.commit("SET_SEARCH_LOADING_COMPANY", false);
        this.$store.commit("SET_SEARCH_INPUT_COMPANY", "");
      }
    },
    debounceInputCompany: function() {
      this.debounceHandlerCompany();
    },

    removeFavorite: async function(id, index) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      this.favorites.splice(index, 1);

      await axios.post(
        process.env.VUE_APP_API_BASE_URL + "/user/favorites/delete",
        {},
        {
          params: {
            session_id: currentSession,
            favoriteID: id,
          },
        }
      );
    },

    chooseFavorite: async function(data, title) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      this.$store.commit("SET_COMPANY", title);

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/CompanyListPrice", {
          params: {
            count: 1,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/CompanyListPrice" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.$store.commit("SET_PRICE", res.data.price);
          this.$store.commit("SET_COMPANIES_COUNT", res.data.count);
        });
    },

    getFavorites: async function() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/favorites/get",
          {},
          {
            params: {
              session_id: currentSession,
              category1: "universal",
              category2: "company",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.favorites.forEach(
            (item) => (item.search1 = JSON.parse(item.search1))
          );
          this.loaded = true;
        });
      this.$store.commit("SET_FAVORITE_COMPANIES", this.favorites);
    },

    searchCompaniesByInput: async function() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      let apiData = [];
      let temp = [];
      this.$store.commit("SET_SEARCH_LOADING_COMPANY", true);

      let companies = [];
      let availableCompanies = [];
      if (this.searchInputCompany != null && !!this.searchInputCompany) {
        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/companies", {
            params: {
              session_id: currentSession,
              profile_id: this.profileId,
              type: "company",
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              sales_from: this.isRightSalesRange() ? this.salesRangeFrom : "",
              sales_to: this.isRightSalesRange() ? this.salesRangeTo : "",
              search: encodeURIComponent(this.searchInputCompany),
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/companies" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const { data } = res.data;
            temp = data.map(function(item) {
              return { data: item, checked: false };
            });
            this.$store.commit("SET_SEARCH_LOADING_COMPANY", false);
          });

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/CompanyListPrice", {
            params: {
              count: 0,
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/CompanyListPrice" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            this.$store.commit("SET_PRICE", res.data.price);
            this.$store.commit("SET_COMPANIES_COUNT", res.data.count);
          });
        this.$store.commit("SET_SEARCH_COMPANIES", temp);
      } else {
        this.$store.commit("SET_SEARCH_COMPANIES", null);
        this.$store.commit("SET_SEARCH_LOADING_COMPANY", false);
      }
    },
    favoriteDrop: function(e) {
      let activeClass = e.target.parentElement;
      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
      } else {
        activeClass.classList.add("open");
      }
    },
  },
  async created() {
    this.$store.commit("SET_SEARCH_COMPANIES", null);
    this.$store.commit("SET_SEARCH_INPUT_COMPANY", null);
    this.$store.commit("SET_SEARCH_LOADING_COMPANY", false);
    await this.getFavorites();
  },
  computed: {
    profileId() {
      return this.$store.getters.fProfileId;
    },
    industry() {
      return this.$store.getters.fIndustry;
    },
    marketArea() {
      return this.$store.getters.fMarketArea;
    },
    salesRangeFrom() {
      return this.$store.getters.salesRangeFrom;
    },
    salesRangeTo() {
      return this.$store.getters.salesRangeTo;
    },
    searchInputCompany() {
      return this.$store.getters.searchInputCompany;
    },

    favoriteCompanies() {
      return this.$store.getters.favoriteCompanies;
    },
    company() {
      return this.$store.getters.company;
    },
    searchCompanies() {
      return this.$store.getters.searchCompanies;
    },
    searchLoadingCompany() {
      return this.$store.getters.searchLoadingCompany;
    },
  },
  watch: {
    favoriteCompanies(newValue, oldValue) {
      this.favorites = this.$store.getters.favoriteCompanies;
    },
    searchInputCompany(newValue, oldValue) {
      this.searchCompaniesByInput();
    },
  },
};
</script>
<style lang="scss"></style>
